module.exports = __webpack_public_path__ + "img/HTML_CONTENT.6515edc1.svg";